// extracted by mini-css-extract-plugin
export default {"dropdown":"EditProfileDropdown-module__dropdown--bOmZU"};